$(document).ready(function () {
    const $body = $('body');

    // Toggle dropdown when trigger is clicked
    $(document).on('click', '.js-dropdown-trigger', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $trigger = $(this);
        const dropdownId = $trigger.attr('aria-controls');
        const $dropdown = $('#' + dropdownId);

        // If the dropdown is already open, close it
        if ($dropdown.hasClass('show')) {
            closeDropdown($dropdown, $trigger);
        } else {
            $('.dropdown-menu.show').each(function () {
                const $openDropdown = $(this);
                const $openTrigger = $('.js-dropdown-trigger[aria-controls="' + $openDropdown.attr('id') + '"]');
                closeDropdown($openDropdown, $openTrigger);
            });
            openDropdown($dropdown, $trigger);
        }
    });

    // Open the dropdown
    function openDropdown($dropdown, $trigger) {
        $dropdown.addClass('show').attr('aria-hidden', 'false');
        $trigger.addClass('show').attr('aria-expanded', 'true');
        $(".myFakeClass").dropdown('toggle');

        $('#primaryNav>.nav-item>.nav-link').removeClass('show').attr('aria-expanded', 'false');
        $('#primaryNav>.nav-item>.dropdown-menu').removeClass('show').attr('aria-hidden', 'true');
        
          
    }

    // Close the dropdown
    function closeDropdown($dropdown, $trigger) {
        $dropdown.removeClass('show').attr('aria-hidden', 'true');
        $trigger.removeClass('show').attr('aria-expanded', 'false');
    }

    // Close the dropdown if clicking outside the dropdown or trigger
    $(document).on('click', function (e) {
        if ($(e.target).closest('.dropdown').length === 0 && $(e.target).closest('.js-dropdown-trigger').length === 0) {
            $('.dropdown-menu.show').each(function () {
                const $openDropdown = $(this);
                const $openTrigger = $('.js-dropdown-trigger[aria-controls="' + $openDropdown.attr('id') + '"]');
                closeDropdown($openDropdown, $openTrigger);
            });
        }
    });

    // Close the dropdown on pressing escape
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $('.dropdown-menu.show').each(function () {
                const $openDropdown = $(this);
                const $openTrigger = $('.js-dropdown-trigger[aria-controls="' + $openDropdown.attr('id') + '"]');
                closeDropdown($openDropdown, $openTrigger);
            });
        }
    });

    // Keyboard navigation within the dropdown
    $('.dropdown-menu a').on('keydown', function (e) {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            const $next = $(this).closest('li').next('li').find('a');
            if ($next.length) {
                $next.focus();
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            const $prev = $(this).closest('li').prev('li').find('a');
            if ($prev.length) {
                $prev.focus();
            }
        }
    });
});